import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import FullHistory from './FullHistory';
import AccountPage from './AccountPage';
import PrivacyPolicy from './Privacy';
import Terms from './Terms';
import AdminDashboard from './AdminDashboard';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/full-history/:userId" element={<FullHistory />} />
        <Route path="/account/:userId" element={<AccountPage />} />
        <Route path="/:userId" element={<Dashboard />} />
        <Route path="/" element={<Dashboard />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </Router>
  );
}